import VMainTitle from "./VMainTitle"
import styles from "./VMain.module.css"

// blocks
import VMainAboutCompany from "./AboutCompany/VMainAboutCompany"
import VMainArtesianBanner from "./ArtesianBanner/VMainArtesianBanner"
import VMainBenefits from "./Benefits/VMainBenefits"
import VMainCatalog from "./Catalog/VMainCatalog"
import VMainPromotion from "./Promotion/VMainPromotion"
import VMainPartners from "./Partners/VMainPartners"
import VMainCertificates from "./Certificates/VMainCertificates"
import VMainNews from "./News/VMainNews"
import VMainVacancies from "./Vacancies/VMainVacancies"

// Banners
import { VMainBannerDefault, VMainBannerDecember16, VMainBannerNewYear } from "./Banners"

const VMain = () => {
  return (
    <>
      {/* Баннер - переключайте между разными версиями в зависимости от праздников */}
      
      {/* Стандартный баннер - для обычных дней */}
      <VMainBannerDefault />
      
      {/* Баннер для 16 декабря - День независимости */}
      {/* <VMainBannerDecember16 /> */}

      {/* Новогодний баннер */}
      {/* <VMainBannerNewYear /> */}

      {/* О компании */}
      <VMainAboutCompany />

      {/* Артезианская скважина - главная фишка */}
      <VMainArtesianBanner />

      

      {/* Наши преимущества */}
      <VMainBenefits />

      {/* Ассортимент */}
      <VMainCatalog />

      {/* Акции */}
      {/* <VMainPromotion /> */}

      {/* Компании которые нам доверяют */}
      <VMainPartners />

      {/* Компании которые нам доверяют */}
      <VMainCertificates />

      {/* Новости */}
      <VMainNews />

      {/* Вакансии */}
      <VMainVacancies />
    </>
  )
}

export default VMain